<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 12 9"
>
  <path [attr.stroke]="color" class="inverted-fill inverted-stroke" d="M1 4L4.33333 7L11 1" stroke-width="2"></path>
</svg>
